export const limitedWorkspaceNavigation = [
  { to: "/limited-workspace/dashboard", label: "Dashboard" },
  { to: "/limited-workspace/employees", label: "Employees" },
  { to: "/limited-workspace/attendance", label: "Attendance" },
  { to: "/limited-workspace/tasks", label: "Tasks" },
  { to: "/limited-workspace/leave", label: "Leave" },
] as const;

// Limited routes use a separate URL namespace, while Access Management stores
// permissions under the normal Teamlio panel paths. Keep the translation in
// one place so the sidebar and direct-route guard make the same decision.
const LIMITED_ACCESS_PATHS: Record<string, string> = {
  "/limited-workspace/dashboard": "/dashboard",
  "/limited-workspace/employees": "/employees",
  "/limited-workspace/attendance": "/attendance",
  "/limited-workspace/tasks": "/tasks",
  "/limited-workspace/planner": "/todo",
  "/limited-workspace/leave": "/leaves",
};

export const accessPathForLimitedRoute = (pathname: string): string | null => {
  const exact = LIMITED_ACCESS_PATHS[pathname];
  if (exact) return exact;

  // Starter-safe utility pages still belong to their parent Access panel.
  if (pathname === "/todo/history") return "/todo";
  if (
    pathname === "/tasks/recently-deleted" ||
    /^\/tasks\/[^/]+(?:\/edit)?$/.test(pathname)
  ) {
    return "/tasks";
  }
  // Settings/Profile are administrative utilities, not Starter feature panels.
  // Their existing role/backend checks remain responsible for access.
  if (pathname.startsWith("/settings/")) return null;
  if (pathname === "/profile") return null;
  return null;
};

export const firstVisibleLimitedPath = (
  isPathVisible: (pathname: string) => boolean
): string => {
  const ordered = [
    ["/dashboard", "/limited-workspace/dashboard"],
    ["/employees", "/limited-workspace/employees"],
    ["/attendance", "/limited-workspace/attendance"],
    ["/todo", "/limited-workspace/planner"],
    ["/tasks", "/limited-workspace/tasks"],
    ["/leaves", "/limited-workspace/leave"],
  ] as const;
  return ordered.find(([accessPath]) => isPathVisible(accessPath))?.[1] ?? "/profile";
};
